import React from 'react';
import PropTypes from 'prop-types';

import Question from './Question';

class QuestionGroup extends React.Component {
  questions = [];
  answers = [];

  constructor(props) {
    super(props);

    this.questions = props.questions.map((question, idx) => ({ qID: idx, ...question, answered: false }));
  }

  render() {
    return (
      <React.Fragment>
        {this.props.title && <h2>{this.props.title}</h2>}
        <div>
          { this.questions.map((question) =>
            <Question
              key={question.qID}
              question={question}
              answers={this.props.answers}
              onAnswer={this.onAnswer.bind(this, question.qID)}
            />
          )}
        </div>
      </React.Fragment>
    );
  }

  isComplete() {
    return !this.questions.some(q => !q.answered);
  }

  onAnswer(qID, id, choice_id, overrideID, answered) {
    let question = this.questions.find(q => q.qID === qID);
    let answers = [...this.answers];
    let answer = answers.find(a => a.id === id || a.id === overrideID);

    if (answer) {
      answer.id = id;
      answer.choice_id = choice_id;
    } else {
      answer = { id: overrideID || id, choice_id };
      answers.push(answer);
    }

    question.answered = answered;
    this.answers = answers.filter(a => a.choice_id);

    this.props.onAnswer(id, choice_id, overrideID, this.isComplete());
  }
}

QuestionGroup.defaultProps = {
  answers: []
};

QuestionGroup.propTypes = {
  title: PropTypes.string,
  answers: PropTypes.array,
  questions: PropTypes.array.isRequired,
  onAnswer: PropTypes.func.isRequired
};

export default QuestionGroup;
